import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserActivityService } from '@services/user-activity.service';
import { BehaviorSubject, interval, filter } from 'rxjs';
import { UserInfo } from '@shared/types/user.type';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private _user = new BehaviorSubject<UserInfo | undefined>(undefined);
  readonly user$ = this._user.asObservable();

  jackpotGroupId?: string;
  gameTag?: string;
  brand?: string;

  constructor(
    private userActivityService: UserActivityService,
    private router: Router,
  ) {}

  setUser(userInfo: UserInfo): void {
    this._user.next(userInfo);
  }

  // TODO: replace with cookie based. Check if cookie is valid periodically. If not, redirect to login
  updateAuthToken(): void {
    // Run every 10 minutes
    interval(10 * 60 * 1000)
      .pipe(
        untilDestroyed(this),
        // this interval must not refresh the token trigger if the user is not active
        filter(() => !this.userActivityService.isUserInactive()),
        // switchMap(() => this.fetchToken()),
      )
      .subscribe({
        next: (user) => {
          // this.setUser(user);
        },
        error: () => {
          this.router.navigate(['/error']);
        },
      });
  }
}
